<div class="cs-dashboard-html-host">
  <div class="statistics-html-container"
       [class.is-loading]="isLoading"
       [innerHTML]="safeHtml"
       (click)="onHtmlClick($event)">
    No data
  </div>
  <!-- Spinner only on the panel that initiated the click; sibling panels just dim.
       Kept in the DOM (no *ngIf) so opacity transitions fade it in/out smoothly. -->
  <div class="cs-dashboard-html-loading-overlay"
       [class.is-active]="isLoading && isClickOrigin"
       aria-hidden="true">
    <div class="loader"></div>
  </div>
</div>
